export default __webpack_public_path__ + "static/media/Icon-Yellow-Alert.ee97dfb5.svg";